module.exports = __webpack_public_path__ + "img/HPSH1.a6906de1.jpg";